import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import tick from '../../../../../../../assets/images/tick.svg';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-success.module.scss';
import Header from '../../../../../../../components/Stake/header';
import OmIcon from '../../../../../../../assets/images/tokens/om-v2.svg';
import { formatToken } from '../../../../../../../helpers/token-helper';
import TxID from '../../../../../../../components/txID';

const WithdrawSuccess = ({ setStatus, withdrowedIndex }) => {
  const hash = useSelector((state) => state.delegator.polkadot.hash);
  const amount = useSelector(
    (state) => state.delegator.polkadot.requestedRewards[withdrowedIndex].amount,
  );

  return (
    <>
      <Header icon={OmIcon} title='OM-Withdrawal' />
      <div className={stylesParent.cardContent}>
        <div className={styles.icon}>
          <img src={tick} alt='' />
        </div>
        <div className={styles.stakedValue}>{formatToken(amount)} OM</div>
        <div className={styles.status}>Withdrawn</div>
        <TxID id={hash} />
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => setStatus(2)}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Done
          </Button>
        </div>
      </div>
    </>
  );
};

WithdrawSuccess.propTypes = {
  setStatus: PropTypes.func.isRequired,
  withdrowedIndex: PropTypes.number.isRequired,
};

export default WithdrawSuccess;
